<template>
  <AdminCrudPage
    collection-name="ziaratTours"
    title="Ziarat Tours"
    singular-title="Tour"
    :fields="fields"
    :columns="columns"
    :seed-data="seedData"
  />
</template>

<script>
import AdminCrudPage from './AdminCrudPage.vue'
import localTour1 from '../../assets/images/localTour-1.jpg'
import madinaZiarat from '../../assets/images/madina/madina-aerial-night.jpg'
import localTour3 from '../../assets/images/localTour-3.jpg'
import localTour4 from '../../assets/images/localTour-4.jpg'

export default {
  name: 'AdminZiarat',
  components: { AdminCrudPage },
  data() {
    return {
      columns: [
        { key: 'title', label: 'Title' },
        { key: 'category', label: 'Category' },
        { key: 'price', label: 'Price' },
        { key: 'duration', label: 'Duration' }
      ],
      fields: [
        { key: 'title', label: 'Title', type: 'text', required: true },
        { key: 'category', label: 'Category (e.g. Makkah, Madina, Historical, Taif)', type: 'text' },
        { key: 'price', label: 'Price (e.g. "Rs 8,500 / PERSON")', type: 'text' },
        { key: 'duration', label: 'Duration (e.g. "Half Day", "Full Day")', type: 'text' },
        { key: 'description', label: 'Description', type: 'textarea' },
        { key: 'image', label: 'Image', type: 'image' }
      ],
      seedData: [
        {
          title: 'Makkah Ziarat Tour',
          category: 'Makkah',
          price: 'Rs 8,500 / PERSON',
          duration: 'Half Day',
          description: 'Visit Jabal al-Nour, the Cave of Hira, Jabal Thawr, Mina, Arafat, Muzdalifah, and the Museum of the Two Holy Mosques.',
          image: localTour1
        },
        {
          title: 'Madina Ziarat Tour',
          category: 'Madina',
          price: 'Rs 7,500 / PERSON',
          duration: 'Half Day',
          description: 'Explore Quba Mosque, Qiblatain Mosque, Mount Uhud and the Martyrs\' Cemetery, and Jannat al-Baqi with a knowledgeable guide.',
          image: madinaZiarat
        },
        {
          title: 'Badr Historical Tour',
          category: 'Historical',
          price: 'Rs 12,000 / PERSON',
          duration: 'Full Day',
          description: 'A day trip from Madina to the historic site of the Battle of Badr, one of the most significant events in Islamic history.',
          image: localTour3
        },
        {
          title: 'Taif Ziarat & Nature Trip',
          category: 'Taif',
          price: 'Rs 9,500 / PERSON',
          duration: 'Full Day',
          description: 'Scenic drive to Taif, visiting sites connected to the Prophet\'s (peace be upon him) journey, along with the rose gardens and cool mountain air.',
          image: localTour4
        }
      ]
    }
  }
}
</script>
